import { useNavigate } from "@tanstack/react-router";
import { Check, ChevronsUpDown } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@monorepo-apps/ui/src/components/dropdown-menu";
import { useWorkspace } from "@/presentation/providers/workspace.provider";
import { WORKSPACES, workspaceMeta } from "@/presentation/data/workspaces";
import { workspaceHome } from "@/presentation/data/sidebar-items";

export function WorkspaceSwitcher() {
  const { currentWorkspace, availableWorkspaces, setWorkspace } = useWorkspace();
  const navigate = useNavigate();
  const current = workspaceMeta(currentWorkspace);
  const CurrentIcon = current.icon;

  const options = WORKSPACES.filter((w) => availableWorkspaces.includes(w.id));
  const canSwitch = options.length > 1;

  const badge = (
    <div className="flex items-center gap-2">
      <div className="ring-sidebar-border flex size-7 items-center justify-center rounded-md ring-1">
        <CurrentIcon className="size-4" />
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-sidebar-foreground text-[13px] font-semibold tracking-tight">
          {current.label}
        </span>
        <span className="text-sidebar-foreground/40 text-[10px] font-medium tracking-widest uppercase">
          Workspace
        </span>
      </div>
    </div>
  );

  if (!canSwitch) {
    return <div className="flex items-center px-1 py-1">{badge}</div>;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="hover:bg-sidebar-accent flex w-full items-center justify-between rounded-md px-1 py-1 transition-colors">
        {badge}
        <ChevronsUpDown className="text-sidebar-foreground/40 size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {options.map((w) => {
          const Icon = w.icon;
          const isActive = w.id === currentWorkspace;
          return (
            <DropdownMenuItem
              key={w.id}
              onSelect={() => {
                if (isActive) return;
                setWorkspace(w.id);
                void navigate({ to: workspaceHome(w.id) });
              }}
              className="gap-2"
            >
              <Icon className="size-4" />
              <span className="flex-1 text-[13px]">{w.label}</span>
              {isActive ? <Check className="size-4" /> : null}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
